import { useState } from 'react';

import { useGetActionPlansByOrigin } from '@/hooks/v2/useGetActionPlansByOrigin';
import { useKimLhc } from '@/context/KimLhc';
import { useApplicationContext } from '@/context/v1/Application/context';

import { ACTION_PLAN_PAGE_SIZE, KIM_LHC_TABLE_NAME } from '../constants';

export function useActionPlanList() {
	const { report_id } = useKimLhc();
	const { company, organization } = useApplicationContext();
	const [page, setPage] = useState(1);

	const { data, isLoading } = useGetActionPlansByOrigin({
		table_name: KIM_LHC_TABLE_NAME,
		column_id: report_id ?? '',
		company_id: company.id,
		organization_id: organization.id,
		limit: ACTION_PLAN_PAGE_SIZE,
		offset: page
	});

	const rows = data?.rows ?? [];
	const total = data?.total ?? 0;
	const currentItem = rows[0] ?? null;

	return { currentItem, total, page, setPage, isLoading };
}
